import React, { useRef, useState } from "react";
import { AppointmentDashboardDTO, DocumentDashboardDTO, ReceiptDashboardDTO, ServiceDashboardDTO } from "../../../../../api/DashboardWidgetDTO";
import { useMediaQuery, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, Avatar, IconButton, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Button, useTheme, Box, CircularProgress } from "@mui/material";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { REACT_APP_PORTAL_API_URL, REACT_APP_PUBLIC_API_URL } from "../../../../../KeyVariables";
import { handleDownload } from "./AnalyzisArchive";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { DashboardWidgetsClient } from "../../../../../api/DashboardWidgetsClient";

export interface PaymentsArchiveProps {
  items: ReceiptDashboardDTO[];
}

export const PaymentsArchive = ({ items }: PaymentsArchiveProps) => {
  const { t }: { t: any } = useTranslation('Portal');
  const iframeRef = useRef(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [selectedReceipt, setSelectedReceipt] = useState<ReceiptDashboardDTO | null>(null);
  const [services, setServices] = useState<ServiceDashboardDTO[]>([]);
  const [loadingServices, setLoadingServices] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  const mapStatusColor = (id) => {
    switch (id) {
      case 2:
        return "rgba(255, 0, 0, 0.1)";
      case 1:
        return "rgba(0, 255, 0, 0.1)";
      case 4:
        return "rgba(238, 255, 0, 0.1)";
      default:
        return "none";
    }
  }

  const mapStatusName = (id) => {
    switch (id) {
      case 2:
        return t('Portal_NotPaid');
      case 1:
        return t('Portal_Paid');
      case 4:
        return t('Portal_Reimbursed');
      default:
        return "none";
    }
  }

  const fetchServices = async (receiptId: number) => {
    setLoadingServices(true);
    try {
      const data = await new DashboardWidgetsClient(REACT_APP_PORTAL_API_URL).paymentsservices(receiptId);
      setServices(data);
    } catch (error) {
      console.error("Ошибка при получении сервисов:", error);
    } finally {
      setLoadingServices(false);
    }
  };

  const handleOpenDialog = (receipt: ReceiptDashboardDTO) => {
    setSelectedReceipt(receipt);
    setServices([]);
    setOpenDialog(true);
    fetchServices(receipt.id!);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedReceipt(null);
    setServices([]);
  };

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{t('Portal_CommonDate')}</TableCell>
            <TableCell>{t('Portal_CommonStatus')}</TableCell>
            <TableCell>{t('Portal_Sum')}</TableCell>
            <TableCell>{t('Portal_CommonClinic')}</TableCell>
            <TableCell>{t('Portal_Services')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.length > 0 ? (
            items.map((item, index) => (
              <TableRow key={index}>
                <TableCell>{item.date ? format(item.date, "dd.MM.yyyy HH:mm") : "-"}</TableCell>
                <TableCell>
                  <Box sx={{ backgroundColor: mapStatusColor(item.status?.id), p: 1, borderRadius: 1, textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {item.status ? mapStatusName(item.status.id) : "-"}
                  </Box>
                </TableCell>
                <TableCell>{item.price ? `${item.price.toFixed(2)} lei` :  "-"}</TableCell>
                <TableCell>
                  {item.clinic?.name || "-"}
                </TableCell>
                <TableCell>
                  <IconButton onClick={() => handleOpenDialog(item)}>
                    <VisibilityIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={5} align="center">
                <Typography>{t('Portal_NoReceipts')}</Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth>
        <DialogTitle>{t("Portal_AssociatedServices")}</DialogTitle>
        <DialogContent>
          {loadingServices ? (
            <Box display="flex" justifyContent="center" alignItems="center" height="200px">
              <CircularProgress />
            </Box>
          ) : services.length > 0 ? (
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>{t('Portal_Service')}</TableCell>
                    <TableCell>{t('Portal_Price')}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {services.map((service, index) => (
                    <TableRow key={index}>
                      <TableCell>{service.name}</TableCell>
                      <TableCell>{service.price?.toFixed(2)} lei</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Typography align="center" sx={{ mt: 2 }}>
              
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>{t("Portal_CommonClose")}</Button>
        </DialogActions>
      </Dialog>
    </TableContainer>
  );
};
